import { twMerge } from 'tailwind-merge';

import { Cell } from '../Cell';

export const ClientMTDOverviewTable = ({ data, pdfMode = false }) => {
  const total = data.metrics[data.metrics.length - 1];
  const formattedData = data.metrics.slice(0, -1);

  return (
    <div className="overflow-auto">
      {pdfMode && (
        <div className="bg-neutral-100 sticky top-0 z-10 grid grid-cols-[300px_repeat(3,414px)_160px] border-t border-t-base-1000 w-fit">
          <Cell title="" type="head" className="border-r border-r-base-1000" />
          <Cell
            title={data.today}
            type="head"
            className="border-r border-r-base-1000 text-center"
          />
          <Cell
            title={data.week}
            type="head"
            className="border-r border-r-base-1000 text-center"
          />
          <Cell
            title={data.month}
            type="head"
            className="border-r border-r-base-1000 text-center"
          />
          <Cell title="" type="head" />
        </div>
      )}
      <div
        className={twMerge(
          'bg-neutral-100 sticky z-10 grid grid-cols-[300px_repeat(9,138px)_160px] border-y border-y-base-1000 w-fit',
          pdfMode ? 'top-[41px]' : 'top-0',
        )}
      >
        <Cell
          title="Client Name"
          type="head"
          className="border-r border-r-base-1000"
        />
        <Cell title="Booked Today" type="head" className="bg-orange" />
        <Cell title="Performed Today" type="head" className="bg-orange" />
        <Cell
          title="More Info Today"
          type="head"
          className="bg-orange border-r border-r-base-1000"
        />
        <Cell title="Booked WTD" type="head" className="bg-green" />
        <Cell title="Performed WTD" type="head" className="bg-green" />
        <Cell
          title="More Info WTD"
          type="head"
          className="bg-green border-r border-r-base-1000"
        />
        <Cell title="Booked MTD" type="head" className="bg-yellow" />
        <Cell title="Performed MTD" type="head" className="bg-yellow" />
        <Cell
          title="More Info MTD"
          type="head"
          className="bg-yellow border-r border-r-base-1000"
        />
        <Cell title="CTD Perform Rate %" type="head" className="bg-brand-200" />
      </div>
      <div
        className={twMerge(
          'bg-neutral-100 sticky z-10 grid grid-cols-[300px_repeat(9,138px)_160px] border-b border-b-base-1000 w-fit',
          pdfMode ? 'top-[83px]' : 'top-[42px]',
        )}
      >
        <Cell
          title="Totals:"
          type="total"
          className="border-r border-r-base-1000"
        />
        <Cell title={total.bookedToday} type="total" />
        <Cell title={total.performedToday} type="total" />
        <Cell
          title={total.moreInfoToday}
          type="total"
          className="border-r border-r-base-1000"
        />
        <Cell title={total.bookedWTD} type="total" />
        <Cell title={total.performedWTD} type="total" />
        <Cell
          title={total.moreInfoWTD}
          type="total"
          className="border-r border-r-base-1000"
        />
        <Cell title={total.bookedMTD} type="total" />
        <Cell title={total.performedMTD} type="total" />
        <Cell
          title={total.moreInfoMTD}
          type="total"
          className="border-r border-r-base-1000"
        />
        <Cell title="-" type="total" />
      </div>
      {formattedData.map((v, idx) => (
        <div
          key={idx}
          className="grid grid-cols-[300px_repeat(9,138px)_160px] border-b border-b-base-400 w-fit"
        >
          <Cell
            title={v.company}
            type="body"
            className="border-r border-r-base-400"
          />
          <Cell title={v.bookedToday} type="body" />
          <Cell title={v.performedToday} type="body" />
          <Cell
            title={v.moreInfoToday}
            type="body"
            className="border-r border-r-base-400"
          />
          <Cell title={v.bookedWTD} type="body" />
          <Cell title={v.performedWTD} type="body" />
          <Cell
            title={v.moreInfoWTD}
            type="body"
            className="border-r border-r-base-400"
          />
          <Cell title={v.bookedMTD} type="body" />
          <Cell title={v.performedMTD} type="body" />
          <Cell
            title={v.moreInfoMTD}
            type="body"
            className="border-r border-r-base-400"
          />
          <Cell title={v.CTDPerformRate} type="body" />
        </div>
      ))}
    </div>
  );
};
